module.exports = __webpack_public_path__ + "media/images/liquorstore-d8590e0fd7c805b3058ffbb293fdd648.jpg";